import { ReactElement, useCallback, useRef } from 'react';

import { FormHandles } from '@unform/core';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { GoBackButton, Button } from '~/components';
import { useLoading } from '~/hooks/loading';
import { IExerciseRequiredForm } from '~/models/Exercise';
import { ExerciseService } from '~/services';
import { handleYupValidationError } from '~/utils';
import { ExerciseSchema } from '~/utils/schemas/ExerciseSchema';

import EditExerciseForm from '../EditExerciseForm';

import * as S from './styles';

interface IExercisesParams {
  segmentName: string;
}

function ExerciseCadaster(): ReactElement {
  const { setLoading } = useLoading();

  const { segmentName } = useParams<IExercisesParams>();
  const formRef = useRef<FormHandles>(null);
  const router = useHistory();

  const handleExerciseCadasterSubmit = useCallback(
    async (data: IExerciseRequiredForm) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        await ExerciseSchema.validate(data, {
          abortEarly: false,
        });

        const result = await ExerciseService.createExercise(data);
        if (result.status === 200) {
          toast.success('Exercício cadastrado com sucesso!');
          router.goBack();
        } else {
          toast.error('Ocorreu um problema ao cadastrar o exercício!');
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleYupValidationError(formRef, error);
      }
    },
    [router],
  );

  const handleCancel = useCallback(() => {
    router.goBack();
  }, [router]);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Cadastrar Exercício de {segmentName}</S.Title>
        </S.Header>
        <EditExerciseForm
          formName="method-cadaster"
          formRef={formRef}
          handleSubmit={handleExerciseCadasterSubmit}
        />
        <S.Footer>
          <Button
            form="method-cadaster"
            type="submit"
            textContent="Salvar"
            variant="black"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
          <Button
            type="button"
            onClick={handleCancel}
            textContent="Cancelar"
            variant="red"
            size="small"
            extraStyles={{
              width: '200px',
            }}
          />
        </S.Footer>
      </S.Container>
    </>
  );
}

export default ExerciseCadaster;
